import { PrismicRichText } from '@prismicio/react';
import { ButtonInline } from '@remote-com/norma/core/button';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { ReadMore } from '../components/ReadMore';
import { ServicesTable } from '../components/ServicesTable';

export const components = {
  hyperlink: ({ node, children }) => {
    const link = node.data.url;
    const props = node.data.target ? { target: node.data.target } : {};
    return (
      <ButtonInline {...props} href={link}>
        {children}
      </ButtonInline>
    );
  },
};

export const GlobalPayrollContainer = styled(ContentContainer)`
  padding-bottom: 20px;
`;

export const Label = styled.div`
  ${({ theme }) => theme.typography.bodyXS};
  margin-bottom: 10px;
  text-transform: uppercase;
  color: var(--colors-irisBlue);
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.scale3};
  ${fluidProp('font-size', '30px', '42px')};
  margin-bottom: 12px;
  color: var(--colors-darkBlue);

  & > * {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    margin: inherit;
  }
`;

export const Description = styled.div`
  ${({ theme }) => theme.typography.body};
  color: var(--colors-lynch);

  & > * {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
`;

export const ServiceBlock = styled.div`
  margin-bottom: 50px;
`;

export const ServicesTitle = styled.div`
  ${({ theme }) => theme.typography.bodyLeadBold};
  color: var(--colors-irisBlue);

  & > * {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    margin: inherit;
  }
`;

export function GlobalPayrollSlice({ slice }) {
  const { primary, fields, context } = transformProperties(slice);
  const {
    globalPayrollLabel,
    globalPayrollTitle,
    globalPayrollDescription,
    payrollReadMoreTitle,
    payrollReadMoreImage,
    convertLinkLabel,
    convertLink,
    questionsLinkLabel,
    questionsLink,
    additionalLinkLabel,
    additionalLink,
  } = primary;

  const readMoreLinks = [
    {
      label: convertLinkLabel,
      link: convertLink,
    },
    {
      label: questionsLinkLabel,
      link: questionsLink,
    },
    {
      label: additionalLinkLabel,
      link: additionalLink,
    },
  ];

  const { services, features } = context;

  return (
    <GlobalPayrollContainer id="global-payroll">
      {globalPayrollLabel && <Label>{globalPayrollLabel}</Label>}
      {fieldHasContent(globalPayrollTitle) && (
        <Title>
          <PrismicRichText field={globalPayrollTitle} />
        </Title>
      )}
      {fieldHasContent(globalPayrollDescription) && (
        <Description>
          <PrismicRichText field={globalPayrollDescription} components={components} />
        </Description>
      )}
      <ServicesTable services={services} features={features} />
      {fields?.map(({ servicesTitle, servicesDescription }, index) => (
        <ServiceBlock key={index}>
          {fieldHasContent(servicesTitle) && (
            <ServicesTitle>
              <PrismicRichText field={servicesTitle} />
            </ServicesTitle>
          )}
          {fieldHasContent(servicesDescription) && (
            <Description>
              <PrismicRichText field={servicesDescription} components={components} />
            </Description>
          )}
        </ServiceBlock>
      ))}
      <ReadMore title={payrollReadMoreTitle} image={payrollReadMoreImage} links={readMoreLinks} />
    </GlobalPayrollContainer>
  );
}
